import {Component, OnDestroy, OnInit} from '@angular/core';
import {Select} from "@ngxs/store";
import {CartState} from "@app/store/state/cart.state";
import {Observable, Subject} from "rxjs";
import {Cart} from "@app/models/cart";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-student-end-info-box',
    templateUrl: './student-end-info-box.component.html',
    styleUrls: ['./student-end-info-box.component.scss']
})
export class StudentEndInfoBoxComponent implements OnInit, OnDestroy {
    @Select(CartState.getCart) private cart$: Observable<Cart>;
    @Select(CartState.item) item$: Observable<any>;

    private onDestroy$ = new Subject<boolean>();
    public hasStudentCondition = false;
    public total: number;
    public isFree: boolean;

    ngOnInit(): void {
        this.cart$.pipe(takeUntil(this.onDestroy$)).subscribe((cart) => {
            this.hasStudentCondition = cart.conditions.some((elt: any) => {
                return elt?.setup?.type == 'system_student_cart_condition';
            });
        });

        this.item$.pipe(takeUntil(this.onDestroy$)).subscribe((item: any) => {
            this.isFree = item.configuration.setup.free;
            this.total = item.prices?.total?.incl_vat;
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
